<template>
  <div>
    <VTooltip
      :text="text"
      :size="size"
      :position="position"
      :extraClass="extraClass"
      :align="align"
      :theme="theme"
      :preLine="preLine"
      :noPadding="noPadding"
      :minWidth="minWidth"
      maxWidth="200px"
      noEllipsis
    >
      <div class="v-hint__wrapper">
        <svg
          width="6"
          height="11"
          viewBox="0 0 6 11"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3.00008 7.35548C2.77984 7.35548 2.60111 7.17674 2.60111 6.95651V5.01033C2.60111 4.7901 2.77984 4.61136 3.00008 4.61136C4.05136 4.61136 4.90656 3.75637 4.90656 2.70508C4.90656 1.6536 4.05136 0.798002 3.00008 0.798002C1.94879 0.798002 1.0936 1.6536 1.0936 2.70508C1.0936 2.92531 0.914857 3.10405 0.694625 3.10405C0.474393 3.10405 0.295654 2.92531 0.295654 2.70508C0.295654 1.21353 1.50872 6.10352e-05 3.00008 6.10352e-05C4.49143 6.10352e-05 5.7045 1.21353 5.7045 2.70508C5.7045 4.06078 4.70189 5.18648 3.39905 5.37998V6.95651C3.39905 7.17674 3.22031 7.35548 3.00008 7.35548Z"
            fill="#979797"
          />
          <path
            d="M2.99992 10.2559C3.41814 10.2559 3.75717 9.91692 3.75717 9.4987C3.75717 9.08049 3.41814 8.74146 2.99992 8.74146C2.58171 8.74146 2.24268 9.08049 2.24268 9.4987C2.24268 9.91692 2.58171 10.2559 2.99992 10.2559Z"
            fill="#979797"
          />
        </svg>
      </div>
    </VTooltip>
  </div>
</template>

<script>
import Vue from "vue";
import VueTypes from "vue-types";
import VTooltip from "@/components/VTooltip";
export default Vue.component("VHint", {
  props: {
    text: VueTypes.string.isRequired,
    size: VueTypes.oneOf(["small", "big", "fit"]),
    align: VueTypes.oneOf(["center", "left", "right"]).def("center"),
    extraClass: VueTypes.string.def(""),
    position: VueTypes.oneOf(["right", "up", "left", "down"]).def("up"),
    theme: VueTypes.oneOf(["light", "dark"]).def("light"),
    minWidth: VueTypes.string,
    preLine: VueTypes.bool,
    noPadding: VueTypes.bool.def(false)
  },
  components: {
    VTooltip
  },

  computed: {
    extraCls() {
      return `hint ${this.extraClass}`;
    }
  }
});
</script>

<style lang="scss" scoped>
$ns: "v-hint";
.#{$ns} {
  &__wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 20px;
    width: 20px;
    border-radius: 50%;
    cursor: default;
    border: 1px solid $secondary-border-color;

    &:hover {
      border: 1px solid $primary-color;
      cursor: pointer;

      path {
        fill: $primary-color;
      }
    }
  }
}
</style>

<style lang="scss">
.hint {
  [tooltip]::after {
    width: fit-content;
    text-align: left;
    padding: 2px 10px;
  }
}
</style>
